import Navbar from '../components/cummon/Navbar';

import Footer from '../components/cummon/Footer';

import PentestHero from '../components/pentest/pentestHero';

import PentestTypes from '../components/pentest/pentestTypes';

import PentestGlobalAudit from '../components/pentest/PentestGlobalAudit';

import PentestTarget from '../components/pentest/pentestTarget';

import PentestWhy from  '../components/pentest/pentestWhy';

import FinalCTA from '../components/pentest/pentestCTA';

import PentestRapport from '../components/pentest/pentestRapport';

import Methodology from '../components/pentest/pentestMyth';




function Pentest() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
        <PentestHero />
        <PentestGlobalAudit />
        <PentestTypes />
        <PentestTarget />
        <PentestWhy />
        <Methodology />
        <PentestRapport />
        <FinalCTA />
      
      <Footer />
      
    
    
    </div>
  );
}

export default Pentest;